var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contactum-fields" },
    [
      !_vm.has_recaptcha_api_keys
        ? [_c("p", [_vm._v(" No Api key ")])]
        : [
            "invisible_recaptcha" != _vm.field.recaptcha_type
              ? _c("div", [_c("img", { attrs: { src: _vm.field.image } })])
              : _c("div", [_c("p", [_vm._v(" Invisible reCaptcha ")])])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }